/* eslint-disable max-lines-per-function */
import React, { useEffect } from "react";
import { Router, RouteComponentProps } from "@reach/router";

import { Grid } from "@material-ui/core";
import NotFound from "pages/not-found";
import { authorizeForRole, Roles } from "components/auth/authorize-for-role";
import Home from "./home";

import FeatureFlagsPage from "./feature-flags";
import Interests from "./interests";

import Lists from "./lists";
import ListsNew from "./lists/new";
import ListsUpdate from "./lists/update";

import Properties from "./properties";
import PropertiesNew from "./properties/new";
import PropertiesUpdate from "./properties/update";

import Organizations from "./organizations";
import OrganizationsNew from "./organizations/new";
import OrganizationsUpdate from "./organizations/update";
import Questions from "./forms-questions";
import Forms from "./forms";
import FormsNew from "./forms/new";
import FormsUpdate from "./forms/update";

import Users from "./users";
import Importers from "./import";

import SideBar from "./sidebar";
import BillingSearchPage from "./billing/billing-search";
import NewBillingPage from "./billing/billing-new";
import LettersSearchPage from "./billing/letters-search";

// layout uses a scroll container w/ static sidebar so scrolling `body` won't work

const scrollToTop = () => document.getElementById("main")?.scroll(0, 0);

const AdminDashboard: React.FC<RouteComponentProps> = () => {
  useEffect(scrollToTop);

  return (
    <div style={{ margin: 8 }}>
      <Grid container spacing={2}>
        <Grid item sm={3} md={2} className="dash-sidebar">
          <SideBar />
        </Grid>
        <Grid id="main" item sm={9} md={10} className="dash-main">
          <Router primary={false}>
            <Home path="/" />

            <Importers path="/importers/*" />

            <BillingSearchPage path="/billing" />
            <BillingSearchPage path="/billing/:month" />
            <NewBillingPage path="/billing/new" />
            <NewBillingPage path="/billing/new/:month" />
            <LettersSearchPage path="/billing/letters/:type/:id/:month" />
            <FeatureFlagsPage path="/feature-flags" />

            <Interests path="/interests" />
            <Users path="/users/*" />

            <Organizations path="/organizations" />
            <OrganizationsNew path="/organizations/new" />
            <OrganizationsUpdate path="/organizations/:id" />

            <Lists path="/lists" />
            <ListsNew path="/lists/new" />
            <ListsUpdate path="/lists/:id" />

            <Properties path="/properties" />
            <PropertiesNew path="/properties/new" />
            <PropertiesUpdate path="/properties/:id" />

            <Questions path="/form-questions" />
            <Forms path="/forms" />
            <FormsNew path="/forms/new" />
            <FormsUpdate path="/forms/:id" />

            <NotFound default />
          </Router>
        </Grid>
      </Grid>
    </div>
  );
};

export default authorizeForRole([Roles.Admin], AdminDashboard);
